import * as React from 'react';
import { UitkText, UitkHeading } from 'uitk-react-text';
import { UitkTextTheme, UitkTypeSize, UitkHeadingLevel, UitkHeadingSize } from 'uitk-react-text/dist/types';
import { MessageAndAccessibilityType } from 'types/shared';

interface TextWithA11yProps {
  messageAndAccessibility: MessageAndAccessibilityType;
  theme?: UitkTextTheme;
  size?: UitkTypeSize;
  inline?: boolean;
  className?: string;
  headingLevel?: UitkHeadingLevel;
  headingSize?: UitkHeadingSize;
}

export const TextWithA11y = ({
  messageAndAccessibility,
  theme,
  size,
  inline,
  className,
  headingLevel,
  headingSize
}: TextWithA11yProps) => (
  <UitkText inline={inline} size={size} theme={theme} className={className}>
    <span aria-hidden={true}>{messageAndAccessibility.text}</span>
    {messageAndAccessibility.accessibilityMessage && (
      <span className="is-visually-hidden">
        <UitkHeading level={headingLevel} size={headingSize}>
          {messageAndAccessibility.accessibilityMessage}
        </UitkHeading>
      </span>
    )}
  </UitkText>
);
